import { io } from "socket.io-client";
import { isAuthenticated } from "../../utils/authStorage";

// Extraer URL base del servidor (sin /api)
const API_URL = import.meta.env.VITE_API_URL;
const SERVER_URL = API_URL.replace(/\/api\/?$/, "");

let socket = null;

// Salas deseadas: se re-emiten al (re)conectar para sobrevivir a carreras de
// conexión y a reconexiones automáticas.
const desiredPlantaRooms = new Set();
let wantsReportsGlobal = false;
let wantsPendientesGlobal = false;

function rejoinDesiredRooms() {
  if (!socket?.connected) return;
  desiredPlantaRooms.forEach((idplanta) =>
    socket.emit("join-planta", idplanta),
  );
  if (wantsReportsGlobal) socket.emit("join-reports-global");
  if (wantsPendientesGlobal) socket.emit("join-pendientes-global");
}

/**
 * Conectar al servidor Socket.io.
 * Las cookies httpOnly se envían automáticamente con withCredentials.
 */
export function connectSocket() {
  if (socket?.connected) return socket;
  if (!isAuthenticated()) return null;

  socket = io(SERVER_URL, {
    withCredentials: true,
    transports: ["polling", "websocket"],
    reconnectionAttempts: 5,
    reconnectionDelay: 3000,
  });

  socket.on("connect", () => {
    console.log("🔌 Socket.io conectado");
    rejoinDesiredRooms();
  });

  socket.on("connect_error", (err) => {
    console.warn("🔌 Socket.io error de conexión:", err.message);
  });

  return socket;
}

/**
 * Desconectar del servidor Socket.io.
 */
export function disconnectSocket() {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
  desiredPlantaRooms.clear();
  wantsReportsGlobal = false;
  wantsPendientesGlobal = false;
}

/**
 * Reconectar el socket si no está conectado.
 * Útil tras renovar el access token para que el socket se autentique con la cookie fresca.
 */
export function reconnectSocket() {
  if (socket?.connected) return;
  disconnectSocket();
  connectSocket();
}

/**
 * Obtener la instancia actual del socket (puede ser null).
 */
export function getSocket() {
  return socket;
}

/**
 * Unirse a la sala de una planta para recibir eventos en tiempo real.
 */
export function joinPlanta(idplanta) {
  if (!idplanta) return;
  desiredPlantaRooms.add(idplanta);
  if (socket?.connected) {
    socket.emit("join-planta", idplanta);
  }
}

/**
 * Salir de la sala de una planta.
 */
export function leavePlanta(idplanta) {
  if (!idplanta) return;
  desiredPlantaRooms.delete(idplanta);
  if (socket?.connected) {
    socket.emit("leave-planta", idplanta);
  }
}

/**
 * Unirse a la sala global de reportes (para Admin/RH que ven todas las plantas).
 */
export function joinReportsGlobal() {
  wantsReportsGlobal = true;
  if (socket?.connected) {
    socket.emit("join-reports-global");
  }
}

/**
 * Salir de la sala global de reportes.
 */
export function leaveReportsGlobal() {
  wantsReportsGlobal = false;
  if (socket?.connected) {
    socket.emit("leave-reports-global");
  }
}

/**
 * Unirse a la sala global de pendientes (para Admin que ve todos los pendientes).
 */
export function joinPendientesGlobal() {
  wantsPendientesGlobal = true;
  if (socket?.connected) {
    socket.emit("join-pendientes-global");
  }
}

/**
 * Salir de la sala global de pendientes.
 */
export function leavePendientesGlobal() {
  wantsPendientesGlobal = false;
  if (socket?.connected) {
    socket.emit("leave-pendientes-global");
  }
}
